/* tslint:disable */
/* eslint-disable */
/**
 * Y-sports-Core API
 * API for managing Y-sports related stuff
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TeamPaymentReceiptStatus } from './TeamPaymentReceiptStatus';
import {
    TeamPaymentReceiptStatusFromJSON,
    TeamPaymentReceiptStatusFromJSONTyped,
    TeamPaymentReceiptStatusToJSON,
} from './TeamPaymentReceiptStatus';

/**
 * 
 * @export
 * @interface TeamPaymentReceipt
 */
export interface TeamPaymentReceipt {
    /**
     * Original filename of the uploaded receipt
     * @type {string}
     * @memberof TeamPaymentReceipt
     */
    fileName: string;
    /**
     * 
     * @type {TeamPaymentReceiptStatus}
     * @memberof TeamPaymentReceipt
     */
    status: TeamPaymentReceiptStatus;
    /**
     * Timestamp when the receipt was uploaded
     * @type {Date}
     * @memberof TeamPaymentReceipt
     */
    uploadedAt?: Date;
}

/**
 * Check if a given object implements the TeamPaymentReceipt interface.
 */
export function instanceOfTeamPaymentReceipt(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fileName" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function TeamPaymentReceiptFromJSON(json: any): TeamPaymentReceipt {
    return TeamPaymentReceiptFromJSONTyped(json, false);
}

export function TeamPaymentReceiptFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamPaymentReceipt {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileName': json['fileName'],
        'status': TeamPaymentReceiptStatusFromJSON(json['status']),
        'uploadedAt': !exists(json, 'uploadedAt') ? undefined : (new Date(json['uploadedAt'])),
    };
}

export function TeamPaymentReceiptToJSON(value?: TeamPaymentReceipt | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fileName': value.fileName,
        'status': TeamPaymentReceiptStatusToJSON(value.status),
        'uploadedAt': value.uploadedAt === undefined ? undefined : (value.uploadedAt.toISOString()),
    };
}

